module.exports = __webpack_public_path__ + "img/ad_1.f8a39b2d.png";